import React, { PropsWithChildren } from 'react';

import styles from './list-view.module.scss';
export const ListView: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <table className={styles['table']}>{children}</table>;
};

export const ListViewHeader: React.FC<React.PropsWithChildren> = ({ children }) => (
  <thead className={styles['table-head']}>
    <tr>{children}</tr>
  </thead>
);

export const ListViewItem = React.forwardRef<
  HTMLTableRowElement,
  PropsWithChildren<React.HTMLAttributes<HTMLTableRowElement>>
>(({ children, className, ...props }, ref) => {
  return (
    <tr
      className={className ? `${styles['row']} ${className}` : styles['row']}
      ref={ref}
      {...props}
    >
      {children}
    </tr>
  );
});

ListViewItem.displayName = 'ListViewItem';
